import { Input, Label } from "@nexus/ui";
import { SET_NAME_MAX } from "@nexus/contracts";
import { useTranslation } from "react-i18next";

export interface CreateSetNameHeadingProps {
  name: string;
  onNameChange: (name: string) => void;
  error?: string | null;
  disabled?: boolean;
}

export function CreateSetNameHeading({
  name,
  onNameChange,
  error,
  disabled,
}: CreateSetNameHeadingProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-0.5">
        <Label htmlFor="persona-set-name">{t("opportunities.setNameLabel")}</Label>
        <span className="text-destructive text-sm" aria-hidden>
          *
        </span>
      </div>
      <Input
        id="persona-set-name"
        value={name}
        onChange={(event) => onNameChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key !== "Enter") return;
          event.preventDefault();
        }}
        maxLength={SET_NAME_MAX}
        disabled={disabled}
        aria-required="true"
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? "persona-set-name-error" : undefined}
      />
      {error ? (
        <p id="persona-set-name-error" role="alert" className="text-xs text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  );
}
